import { Component, OnInit, Input } from '@angular/core'

@Component({
	selector: 'app-tab-rounded',
	templateUrl: './tab-rounded.component.html',
	styleUrls: ['./tab-rounded.component.scss'],
})
export class TabRoundedComponent implements OnInit {
	@Input('tabTitle') title: string | undefined
	@Input() active = false
	constructor() {}

	ngOnInit(): void {}
}
